import { extend, locale } from 'dayjs'
import 'dayjs/locale/ru'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import duration from 'dayjs/plugin/duration'
import isBetween from 'dayjs/plugin/isBetween'
import isoWeek from 'dayjs/plugin/isoWeek'
import isToday from 'dayjs/plugin/isToday'
import isYesterday from 'dayjs/plugin/isYesterday'
import relativeTime from 'dayjs/plugin/relativeTime'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import weekday from 'dayjs/plugin/weekday'
import { Plugin } from 'vue'

export const dayjsPlugin: Plugin = {
  install: () => {
    extend(utc)
    extend(timezone)
    extend(customParseFormat)
    extend(isoWeek)
    extend(weekday)
    extend(isToday)
    extend(isBetween)
    extend(isYesterday)
    extend(duration)
    extend(relativeTime)
    locale('ru')
  },
}
